import React, { useEffect } from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { useLazyGetProfileDistributionQuery } from "../../../../services/Api";

const CountryDistribution = () => {
  const [trigger, { data, isLoading, error }] =
    useLazyGetProfileDistributionQuery();
  useEffect(() => {
    trigger();
  }, []);
  // Custom Dot Component for scatter plot
  const renderCustomDot = (props) => {
    const { cx, cy, fill, r } = props;
    return <circle cx={cx} cy={cy} r={r} fill={fill} />;
  };

  return (
    <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full">
      <h3 className="text-lg mb-4 font-roboto-mono text-[18px] font-bold">
        Profiles Distribution by Country
      </h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="110%">
          <ScatterChart margin={{ top: 20, right: 20, bottom: 20, left: -20 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#333333" />
            <XAxis
              dataKey="x"
              name="country"
              tick={{ fontSize: 12 }}
              tickLine={false}
              axisLine={{ stroke: "#333333" }}
            />
            <YAxis
              dataKey="y"
              name="count"
              domain={[0, 100]}
              tick={{ fontSize: 12 }}
              tickLine={false}
              axisLine={{ stroke: "#333333" }}
              ticks={[0, 20, 40, 60, 80, 100]}
            />
            <Scatter
              name="male"
              data={data?.data?.male}
              fill="#F2D53F"
              shape={(props) => renderCustomDot({ ...props, r: 10 })} // Custom dot size
            />
            <Scatter
              name="female"
              data={data?.data?.female}
              fill="#5D733C"
              shape={(props) => renderCustomDot({ ...props, r: 7 })} // Custom dot size
            />
          </ScatterChart>
        </ResponsiveContainer>
      </div>
      <div className="flex justify-center gap-4 mt-4">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-[#F2D53F]"></div>
          <span className="text-sm font-quicksand text-[14px] font-medium text-black">
            Male
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-[#5D733C]"></div>
          <span className="text-sm font-quicksand text-[14px] font-medium text-black">
            Female
          </span>
        </div>
      </div>
    </div>
  );
};

export default CountryDistribution;
